export const getPercentage = (decimalValue) => `${decimalValue * 100}%`
